import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "./LatestNewsSection.css";
import SidebarNewsList from "./SidebarNewsList";
import PopularCategories from "./PopularCategories";
import Advertisement from "./Advertisement";

// Import your icons
import InstagramIcon from "../assets/icons/instagram.png";
import TwitterIcon from "../assets/icons/twitter.png";
import TelegramIcon from "../assets/icons/telegram.png";

const LatestNewsSection = () => {
  // Start "page" at 3 because we’ll initially load page 1 and page 2 manually
  const [page, setPage] = useState(3);

  // A single array to store all posts
  const [posts, setPosts] = useState([]);

  // Whether we can load more pages
  const [hasMore, setHasMore] = useState(true);

  // 1. Fetch page 1 and page 2 on mount
  useEffect(() => {
    const fetchInitialPages = async () => {
      try {
        // Fetch page 1
        const res1 = await axios.get(
          `https://khanehyeghtesad.com:8000/api/page/1/`
        );
        // Fetch page 2
        const res2 = await axios.get(
          `https://khanehyeghtesad.com:8000/api/page/2/`
        );

        // Combine results
        const combinedPosts = [...(res1.data || []), ...(res2.data || [])];

        // If no data at all, mark hasMore as false
        if (combinedPosts.length === 0) {
          setHasMore(false);
        }

        setPosts(combinedPosts);
      } catch (err) {
        console.error("Error fetching initial pages:", err);
        setHasMore(false);
      }
    };

    fetchInitialPages();
  }, []);

  // 2. Fetch subsequent pages (page >= 3) whenever "page" changes
  useEffect(() => {
    // We only want to run this effect if page >= 3
    if (page < 3) return;

    const fetchMorePages = async () => {
      try {
        const res = await axios.get(
          `https://khanehyeghtesad.com:8000/api/page/${page}/`
        );
        // If no posts, we've reached the end
        if (!res.data || res.data.length === 0) {
          setHasMore(false);
          return;
        }
        // Append new posts
        setPosts((prev) => [...prev, ...res.data]);
      } catch (err) {
        console.error(`Error fetching page ${page}:`, err);
        setHasMore(false);
      }
    };

    fetchMorePages();
  }, [page]);

  // Load the next page
  const handleLoadMore = () => {
    setPage((prevPage) => prevPage + 1);
  };

  return (
    <section id="latest-news" className="latest-news-section">
      <div className="latest-news-container">
        <div className="main-content-latest">
          <h2 className="section-title">آخرین اخبار</h2>

          {/* Grid layout for the first 6 posts */}
          <div className="news-grid-latest">
            {posts.slice(0, 6).map((news) => (
              <Link
                to={`/article/${news.slug}`}
                key={news.slug}
                className="news-item-link-latest"
              >
                <div className="news-card-latest">
                  <div className="news-image-container">
                    <img
                      src={
                        news.image_file
                          ? `data:image/jpeg;base64,${news.image_file}`
                          : "https://via.placeholder.com/300x200"
                      }
                      alt={news.title}
                      className="news-image-latest"
                      loading="lazy"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "https://via.placeholder.com/300x200";
                      }}
                    />
                  </div>
                  <div className="news-content-wrapper">
                    <div className="news-category-badge-latest">
                      {news.category.join(" - ")}
                    </div>
                    <p className="news-quote-latest">{news.quote}</p>
                    <h3 className="news-title-latest">{news.title}</h3>
                    <p className="news-date-latest">
                      {news.jalali_full_date || news.date}
                    </p>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {/* Detailed layout for the rest (starting from index 6 onward) */}
          <div className="news-detailed-latest">
            {posts.slice(6).map((news) => (
              <Link
                to={`/article/${news.slug}`}
                key={news.slug}
                className="news-item-link-detailed"
              >
                <div className="news-detailed-card">
                  <img
                    src={
                      news.image_file
                        ? `data:image/jpeg;base64,${news.image_file}`
                        : "https://via.placeholder.com/300x200"
                    }
                    alt={news.title}
                    className="news-detailed-image-latest"
                    loading="lazy"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "https://via.placeholder.com/300x200";
                    }}
                  />
                  <div className="news-detailed-content">
                    <div className="news-category-badge-latest">
                      {news.category.join(" - ")}
                    </div>
                    <p className="news-quote-latest">{news.quote}</p>
                    <h3 className="news-detailed-title">{news.title}</h3>
                    <p className="news-detailed-meta">
                      {news.jalali_full_date || news.date}
                    </p>
                    <p className="news-detailed-description">
                      {news.description}
                    </p>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {/* "Load More" button */}
          {hasMore && (
            <button className="load-more-btn" onClick={handleLoadMore}>
              نمایش بیشتر
            </button>
          )}
        </div>

        <aside className="sidebar">
          <div className="connect-us">
            <h3 className="sidebar-title">تماس با ما</h3>
            <div className="social-box-latest">
              <div className="social-item-latest">
                <a
                  href="https://twitter.com/khanehyeghtesad"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link-latest"
                >
                  <img
                    src={TwitterIcon}
                    alt="Twitter"
                    className="social-icon-latest"
                  />
                  <p>khanehyeghtesad</p>
                </a>
              </div>
              <div className="social-item-latest">
                <a
                  href="https://instagram.com/khanehyeghtesad"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link-latest"
                >
                  <img
                    src={InstagramIcon}
                    alt="Instagram"
                    className="social-icon-latest"
                  />
                  <p>khanehyeghtesad</p>
                </a>
              </div>
              <div className="social-item-latest">
                <a
                  href="https://t.me/khanehyeghtesad"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link-latest"
                >
                  <img
                    src={TelegramIcon}
                    alt="Telegram"
                    className="social-icon-latest"
                  />
                  <p>khanehyeghtesad</p>
                </a>
              </div>
            </div>
          </div>

          {/* Sidebar components */}
          <SidebarNewsList />
          <PopularCategories />
          <Advertisement />
        </aside>
      </div>
    </section>
  );
};

export default LatestNewsSection;
